import React from "react";
import { Mail, Phone, MapPin, CheckCircle2, XCircle } from "lucide-react";

const ContactInfoSection = ({ promoter }) => {
  if (!promoter) return null;

  const emailVerified = !!promoter.email_verified_at;
  const phoneVerified = !!promoter.phone_number_verified_at;

  const formatAddress = (address) => {
    if (!address || typeof address !== "object") return "Not specified";
    const parts = [
      address.street_address_1,
      address.street_address_2,
      address.city,
      address.region,
      address.zip_code,
      address.country,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "Not specified";
  };

  return (
    <div className="p-6 bg-white rounded-xl border border-gray-200">
      <h3 className="flex gap-2 items-center mb-4 text-lg font-semibold text-gray-900">
        <Mail className="w-5 h-5 text-[#FF6C6C]" />
        Contact Information
      </h3>
      <div className="space-y-4">
        <div className="flex gap-3 items-start">
          <div className={`p-2 rounded-lg ${emailVerified ? "bg-green-100" : "bg-gray-100"}`}>
            <Mail className={`w-5 h-5 ${emailVerified ? "text-green-600" : "text-gray-400"}`} />
          </div>
          <div className="flex-1">
            <div className="flex gap-2 items-center mb-1">
              <p className="font-medium text-gray-900">Email Address</p>
              {emailVerified ? (
                <CheckCircle2 className="w-4 h-4 text-green-500" title="Verified" />
              ) : (
                <XCircle className="w-4 h-4 text-red-500" title="Not Verified" />
              )}
            </div>
            <p className="text-sm text-gray-600">{promoter.email || "Not provided"}</p>
            {promoter.email_verified_at && (
              <p className="mt-1 text-xs text-gray-500">
                Verified: {new Date(promoter.email_verified_at).toLocaleDateString()}
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-3 items-start">
          <div className={`p-2 rounded-lg ${phoneVerified ? "bg-green-100" : "bg-gray-100"}`}>
            <Phone className={`w-5 h-5 ${phoneVerified ? "text-green-600" : "text-gray-400"}`} />
          </div>
          <div className="flex-1">
            <div className="flex gap-2 items-center mb-1">
              <p className="font-medium text-gray-900">Phone Number</p>
              {phoneVerified ? (
                <CheckCircle2 className="w-4 h-4 text-green-500" title="Verified" />
              ) : (
                <XCircle className="w-4 h-4 text-red-500" title="Not Verified" />
              )}
            </div>
            <p className="text-sm text-gray-600">{promoter.phone_number || "Not provided"}</p>
            {promoter.phone_number_verified_at && (
              <p className="mt-1 text-xs text-gray-500">
                Verified: {new Date(promoter.phone_number_verified_at).toLocaleDateString()}
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-3 items-start">
          <div className="p-2 bg-blue-100 rounded-lg">
            <MapPin className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1">
            <p className="mb-1 font-medium text-gray-900">Address</p>
            <p className="text-sm text-gray-600">{formatAddress(promoter.address)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;

